import React from "react";
import { Page, Text, View, Document, StyleSheet } from "@react-pdf/renderer";

const styles = StyleSheet.create({
  page: {
    flexDirection: "column",
    backgroundColor: "white",
    padding: 28,
  },
  header: {
    marginBottom: 18,
    textAlign: "center",
    fontSize: 24,
    color: "#6c584c",
  },
  momentSection: {
    marginBottom: 16,
    padding: 12,
    border: "1 solid #d7ccc6",
    borderRadius: 8,
  },
  momentTitle: {
    marginBottom: 8,
    fontSize: 16,
    color: "#6c584c",
  },
  itemBlock: {
    marginBottom: 8,
    paddingBottom: 8,
    borderBottom: "1 solid #eee3de",
  },
  itemTitle: {
    fontSize: 13,
    marginBottom: 4,
  },
  itemText: {
    fontSize: 11,
    marginBottom: 2,
  },
});

function ParcProfPdf(props) {
  const moments = props.moments || {};
  const nom = props.nom;
  const prenom = props.prenom;
  const orderedMoments = Object.values(moments).filter(
    (moment) => (moment.items || []).length > 0
  );

  return (
    <Document>
      <Page size="A4" style={styles.page}>
        <View style={styles.header}>
          <Text>{`Planning de ${nom} ${prenom}`}</Text>
        </View>

        {orderedMoments.map((moment) => (
          <View style={styles.momentSection} key={moment.indexMoment}>
            <Text style={styles.momentTitle}>{moment.momentLabel}</Text>
            {moment.items.map((item) => (
              <View
                style={styles.itemBlock}
                key={`${item.activiteId}-${item.parcoursId}-${item.indexMoment}`}
              >
                <Text style={styles.itemTitle}>
                  {item.activite?.nom || `Activite ${item.activiteId}`}
                </Text>
                <Text style={styles.itemText}>{`Parcours ${item.parcoursId}`}</Text>
                {item.activite?.lieu && (
                  <Text style={styles.itemText}>{`Lieu : ${item.activite.lieu}`}</Text>
                )}
                {item.activite?.lieu_rdv && (
                  <Text style={styles.itemText}>{`Rendez-vous : ${item.activite.lieu_rdv}`}</Text>
                )}
              </View>
            ))}
          </View>
        ))}
      </Page>
    </Document>
  );
}

export default ParcProfPdf;
